import { Button, Modal, Steps } from "antd";
import React from "react";
import { useHistory } from "react-router-dom";

function ModalJumio(props) {
  const { isOpen, onClose } = props;
  const history = useHistory();
  return (
    <Modal
      className="w-modal-Verify width-modal-swap user user-change p-4"
      closable={false}
      visible={isOpen}
      footer={
        <>
          <div className="d-flex " style={{ gap: 20 }}>
            <Button
              onClick={() => onClose()}
              className="btn-primary-new-iux-ghost w-100 "
              style={{ borderRadius: 8 }}
            >
              Do it later
            </Button>
            <Button
              onClick={() => {
                history.push(
                  `/${localStorage.getItem("locale")}/wallet/account`
                );
                onClose();
              }}
              className="btn-primary-new-iux w-100 "
              type="primary"
              style={{ borderRadius: 8 }}
            >
              Get started now
            </Button>
          </div>
        </>
      }
      onCancel={() => {
        onClose();
      }}
    >
      <h4 className="fs-20 fw-700">Identity Verification Steps</h4>
      <p>This will only take a few minutes.</p>
      <div className="mtc-24 mbc-24">
        <Steps
          direction="vertical"
          status="success"
          //   current={2}
          items={[
            {
              status: "wait",
              icon: (
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="22"
                    viewBox="0 0 28 22"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.21536 0.332032H21.7848C22.4877 0.332009 23.094 0.331988 23.5935 0.372793C24.1206 0.415861 24.6449 0.510949 25.1494 0.768008C25.902 1.1515 26.514 1.76342 26.8974 2.51607C27.1545 3.02058 27.2496 3.54487 27.2927 4.072C27.3335 4.57142 27.3334 5.17776 27.3334 5.88061V16.1168C27.3334 16.8196 27.3335 17.426 27.2927 17.9254C27.2496 18.4525 27.1545 18.9768 26.8974 19.4813C26.514 20.234 25.902 20.8459 25.1494 21.2294C24.6449 21.4865 24.1206 21.5815 23.5935 21.6246C23.094 21.6654 22.4877 21.6654 21.7848 21.6654H6.21539C5.51251 21.6654 4.90615 21.6654 4.40671 21.6246C3.87959 21.5815 3.35529 21.4865 2.85079 21.2294C2.09814 20.8459 1.48622 20.234 1.10272 19.4813C0.845666 18.9768 0.750578 18.4525 0.70751 17.9254C0.666705 17.426 0.666725 16.8196 0.666749 16.1168V5.88064C0.666725 5.17778 0.666705 4.57143 0.70751 4.072C0.750578 3.54487 0.845666 3.02058 1.10272 2.51607C1.48622 1.76342 2.09814 1.1515 2.85079 0.768008C3.35529 0.510949 3.87959 0.415861 4.40671 0.372793C4.90614 0.331988 5.51249 0.332009 6.21536 0.332032ZM4.62386 3.0306C4.26165 3.0602 4.12736 3.11043 4.06143 3.14403C3.81055 3.27186 3.60657 3.47583 3.47874 3.72671C3.44515 3.79264 3.39491 3.92693 3.36532 4.28915C3.33445 4.66693 3.33342 5.1633 3.33342 5.93203V16.0654C3.33342 16.8341 3.33445 17.3305 3.36532 17.7083C3.39491 18.0705 3.44515 18.2048 3.47874 18.2707C3.60657 18.5216 3.81055 18.7255 4.06143 18.8534C4.12736 18.887 4.26165 18.9372 4.62386 18.9668C5.00165 18.9977 5.49801 18.9987 6.26675 18.9987H21.7334C22.5022 18.9987 22.9985 18.9977 23.3763 18.9668C23.7385 18.9372 23.8728 18.887 23.9387 18.8534C24.1896 18.7255 24.3936 18.5216 24.5214 18.2707C24.555 18.2048 24.6053 18.0705 24.6348 17.7083C24.6657 17.3305 24.6668 16.8341 24.6668 16.0654V5.93203C24.6668 5.1633 24.6657 4.66693 24.6348 4.28915C24.6053 3.92693 24.555 3.79264 24.5214 3.72671C24.3936 3.47583 24.1896 3.27186 23.9387 3.14403C23.8728 3.11043 23.7385 3.0602 23.3763 3.0306C22.9985 2.99974 22.5022 2.9987 21.7334 2.9987H6.26675C5.49801 2.9987 5.00165 2.99974 4.62386 3.0306ZM7.33342 7.66537C7.33342 6.19261 8.52732 4.9987 10.0001 4.9987C11.4728 4.9987 12.6668 6.19261 12.6668 7.66537C12.6668 9.13813 11.4728 10.332 10.0001 10.332C8.52732 10.332 7.33342 9.13813 7.33342 7.66537ZM15.3334 6.9987C15.3334 6.26232 15.9304 5.66537 16.6668 5.66537H22.0001C22.7365 5.66537 23.3334 6.26232 23.3334 6.9987C23.3334 7.73508 22.7365 8.33203 22.0001 8.33203H16.6668C15.9304 8.33203 15.3334 7.73508 15.3334 6.9987ZM15.3334 10.9987C15.3334 10.2623 15.9304 9.66537 16.6668 9.66537H22.0001C22.7365 9.66537 23.3334 10.2623 23.3334 10.9987C23.3334 11.7351 22.7365 12.332 22.0001 12.332H16.6668C15.9304 12.332 15.3334 11.7351 15.3334 10.9987ZM10.0001 14.332C8.47341 14.332 7.48819 15.2059 7.29404 15.987C7.11642 16.7016 6.39309 17.137 5.67846 16.9593C4.96382 16.7817 4.52849 16.0584 4.70612 15.3437C5.26834 13.0818 7.57742 11.6654 10.0001 11.6654C12.4227 11.6654 14.7318 13.0818 15.294 15.3437C15.4717 16.0584 15.0363 16.7817 14.3217 16.9593C13.6071 17.137 12.8838 16.7016 12.7061 15.987C12.512 15.2059 11.5268 14.332 10.0001 14.332Z"
                      fill="#1CB894"
                    />
                  </svg>
                </>
              ),
              title: (
                <div className="fs-14">
                  <p style={{ color: "#696969", lineHeight: "normal" }}>
                    1. Confirm Document Information <br />
                    <span style={{ color: "#B3B3B3" }}>
                      Successfully checked
                    </span>
                  </p>
                </div>
              ),
              //   subTitle: <p>Successfully checked</p>,
              description: <div style={{ minHeight: 32 }} className=""></div>,
            },
            {
              status: "wait",
              icon: (
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <path
                      d="M18.4 13.6H18.408M13.6005 13.5999H13.6085M12.7995 17.5996C12.7995 17.5996 13.9995 19.1996 15.9995 19.1996C17.9995 19.1996 19.1995 17.5996 19.1995 17.5996M22.6667 4H25.3333C26.8061 4 28 5.19391 28 6.66667V9.33333M28 22.6667V25.3333C28 26.8061 26.8061 28 25.3333 28H22.6667M9.33333 28H6.66667C5.19391 28 4 26.8061 4 25.3333V22.6667M4 9.33333V6.66667C4 5.19391 5.19391 4 6.66667 4H9.33333M18.8 13.6C18.8 13.8209 18.6209 14 18.4 14C18.1791 14 18 13.8209 18 13.6C18 13.3791 18.1791 13.2 18.4 13.2C18.6209 13.2 18.8 13.3791 18.8 13.6ZM14.0005 13.5999C14.0005 13.8208 13.8214 13.9999 13.6005 13.9999C13.3796 13.9999 13.2005 13.8208 13.2005 13.5999C13.2005 13.379 13.3796 13.1999 13.6005 13.1999C13.8214 13.1999 14.0005 13.379 14.0005 13.5999ZM24 16C24 20.4183 20.4183 24 16 24C11.5817 24 8 20.4183 8 16C8 11.5817 11.5817 8 16 8C20.4183 8 24 11.5817 24 16Z"
                      stroke="#1CB894"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </>
              ),
              title: (
                <div className="fs-14">
                  <p style={{ color: "#696969", lineHeight: "normal" }}>
                    2. Confirm Facial Authentication <br />
                    <span style={{ color: "#B3B3B3" }}>
                      Successfully checked
                    </span>
                  </p>
                </div>
              ),
              //   subTitle: <p>Successfully checked</p>,
              description: <div style={{ minHeight: 32 }} className=""></div>,
            },
            {
              icon: (
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.8819 2.66797L17.3333 2.66797C17.6869 2.66797 18.026 2.80845 18.2761 3.0585L26.2761 11.0585C26.5261 11.3085 26.6666 11.6477 26.6666 12.0013V23.786C26.6666 24.4889 26.6666 25.0952 26.6258 25.5947C26.5828 26.1218 26.4877 26.6461 26.2306 27.1506C25.8471 27.9032 25.2352 28.5152 24.4825 28.8987C23.978 29.1557 23.4538 29.2508 22.9266 29.2939C22.4272 29.3347 21.8209 29.3347 21.118 29.3346H10.8818C10.179 29.3347 9.57264 29.3347 9.07322 29.2939C8.54609 29.2508 8.0218 29.1557 7.51729 28.8987C6.76464 28.5152 6.15272 27.9032 5.76923 27.1506C5.51217 26.6461 5.41708 26.1218 5.37401 25.5947C5.33321 25.0952 5.33323 24.4889 5.33325 23.786V8.21658C5.33323 7.51371 5.33321 6.90736 5.37401 6.40793C5.41708 5.88081 5.51217 5.35652 5.76923 4.85201C6.15272 4.09936 6.76464 3.48744 7.51729 3.10395C8.0218 2.84689 8.54609 2.7518 9.07322 2.70873C9.57265 2.66793 10.179 2.66795 10.8819 2.66797ZM9.29037 5.36654C8.92815 5.39614 8.79386 5.44637 8.72793 5.47996C8.47705 5.60779 8.27308 5.81177 8.14525 6.06265C8.11166 6.12858 8.06142 6.26287 8.03182 6.62509C8.00096 7.00287 7.99992 7.49923 7.99992 8.26797V23.7346C7.99992 24.5034 8.00096 24.9997 8.03182 25.3775C8.06142 25.7397 8.11166 25.874 8.14525 25.94C8.27308 26.1908 8.47705 26.3948 8.72793 26.5226C8.79386 26.5562 8.92815 26.6065 9.29037 26.6361C9.66815 26.6669 10.1645 26.668 10.9333 26.668H21.0666C21.8353 26.668 22.3317 26.6669 22.7095 26.6361C23.0717 26.6065 23.206 26.5562 23.2719 26.5226C23.5228 26.3948 23.7268 26.1908 23.8546 25.94C23.8882 25.874 23.9384 25.7397 23.968 25.3775C23.9989 24.9997 23.9999 24.5034 23.9999 23.7346V13.3346L19.4241 13.3346C19.0875 13.3347 18.7598 13.3347 18.4823 13.312C18.1775 13.2871 17.8178 13.2284 17.4559 13.044C16.9542 12.7883 16.5462 12.3804 16.2906 11.8786C16.1062 11.5167 16.0474 11.1571 16.0225 10.8523C15.9998 10.5747 15.9999 10.247 15.9999 9.9105C15.9999 9.89634 15.9999 9.88216 15.9999 9.86797V5.33464H10.9333C10.1645 5.33464 9.66815 5.33567 9.29037 5.36654ZM18.6666 7.22026L22.1143 10.668H19.4666C19.0712 10.668 18.8549 10.6669 18.6994 10.6542C18.6932 10.6537 18.6874 10.6532 18.6819 10.6527C18.6813 10.6472 18.6808 10.6413 18.6803 10.6351C18.6676 10.4797 18.6666 10.2633 18.6666 9.86797V7.22026ZM10.6666 12.0013C10.6666 11.2649 11.2635 10.668 11.9999 10.668H13.3333C14.0696 10.668 14.6666 11.2649 14.6666 12.0013C14.6666 12.7377 14.0696 13.3346 13.3333 13.3346H11.9999C11.2635 13.3346 10.6666 12.7377 10.6666 12.0013ZM10.6666 17.3346C10.6666 16.5983 11.2635 16.0013 11.9999 16.0013H19.9999C20.7363 16.0013 21.3333 16.5983 21.3333 17.3346C21.3333 18.071 20.7363 18.668 19.9999 18.668H11.9999C11.2635 18.668 10.6666 18.071 10.6666 17.3346ZM10.6666 22.668C10.6666 21.9316 11.2635 21.3346 11.9999 21.3346H19.9999C20.7363 21.3346 21.3333 21.9316 21.3333 22.668C21.3333 23.4044 20.7363 24.0013 19.9999 24.0013H11.9999C11.2635 24.0013 10.6666 23.4044 10.6666 22.668Z"
                      fill="#A3A3A3"
                    />
                  </svg>
                </>
              ),
              title: (
                <div className="fs-14">
                  <p style={{ color: "#696969", lineHeight: "normal" }}>
                    3. Add Profile Information <br />
                    <span style={{ color: "#B3B3B3" }}>
                      Fill in your profile details to open a real account
                    </span>
                  </p>
                </div>
              ),
              //   subTitle: <p>Successfully checked</p>,
              description: <div style={{ minHeight: 0 }} className=""></div>,
            },
          ]}
        />
      </div>
    </Modal>
  );
}

export default ModalJumio;
